const toInteger = (value) => {
  if (value === undefined || value === null || value === '') return null;
  const parsed = Number.parseInt(value, 10);
  return Number.isInteger(parsed) ? parsed : null;
};

export const buildDeliveryGuideLineKeys = ({
  varietyId,
  varietyPriceId,
  metricUnit,
  priceIndex,
} = {}) => {
  const keys = [];
  const normalizedVarietyId = toInteger(varietyId);
  if (normalizedVarietyId === null) return keys;
  const normalizedVarietyPriceId = toInteger(varietyPriceId);
  if (normalizedVarietyPriceId !== null) {
    keys.push(`${normalizedVarietyId}-vp-${normalizedVarietyPriceId}`);
  }
  if (metricUnit) {
    const normalizedMetric = String(metricUnit).trim().toLowerCase();
    if (normalizedMetric) {
      const key = `${normalizedVarietyId}-mu-${normalizedMetric}`;
      if (!keys.includes(key)) keys.push(key);
    }
  }
  const normalizedPriceIndex = toInteger(priceIndex);
  if (normalizedPriceIndex !== null) {
    const key = `${normalizedVarietyId}-pi-${normalizedPriceIndex}`;
    if (!keys.includes(key)) keys.push(key);
  }
  if (keys.length === 0) {
    keys.push(`${normalizedVarietyId}-na`);
  }
  return keys;
};

export const buildDeliveryGuideLineKey = (line) =>
  buildDeliveryGuideLineKeys(line)[0] || '';

export const resolveVarietyPriceForGuideItem = (variety, item) => {
  if (!variety) return null;
  const normalizedVarietyPriceId = toInteger(item?.varietyPriceId);
  if (normalizedVarietyPriceId !== null) {
    const match = (variety.VarietyPrices || []).find(
      (price) => Number(price.id) === normalizedVarietyPriceId
    );
    if (match) return match;
  }
  const normalizedPriceIndex = toInteger(item?.priceIndex);
  if (normalizedPriceIndex !== null) {
    return (variety.VarietyPrices || [])[normalizedPriceIndex] || null;
  }
  if (item?.metricUnit) {
    const normalizedUnit = String(item.metricUnit).trim().toLowerCase();
    if (normalizedUnit) {
      const byUnit = (variety.VarietyPrices || []).find(
        (price) => String(price.metricUnit || '').trim().toLowerCase() === normalizedUnit
      );
      if (byUnit) return byUnit;
    }
  }
  return null;
};
